import { Response } from "Data/interfaces";
import { RouteForm } from "Pages/CreateRoute/createRoute";
import { baseApi } from "./baseApi";

export const parserApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    bulkUpload: builder.mutation<Response<RouteForm>, unknown>({
      query: (data) => {
        return {
          url: "routes-uploader",
          method: "POST",
          body: data,
        };
      },
    }),
  }),
});

export const { useBulkUploadMutation } = parserApi;
